import { useDispatch, useSelector } from "react-redux";
import { updateIntegration, Integration } from "../../redux/integration/integrationSlice";
import { RootState } from "../../redux";
import { AppDispatch } from "../../redux";

const useUpdateIntegration = () => {
    const dispatch = useDispatch<AppDispatch>();
    const integrationState = useSelector((state: RootState) => state.integration);
    const integration = integrationState?.integration || null;
    const loading = integrationState?.isLoading || false;
    const error = integrationState?.error || null;

    const updateIntegrationAction = async (integration: Integration) => {
        // unwrap() rethrows on rejection so callers can react to real API failures
        return await dispatch(updateIntegration(integration)).unwrap();
    }
    
    return {
        integration,
        loading,
        error,
        updateIntegrationAction
    }
}

export default useUpdateIntegration; 